import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { OrderCategory } from '../../types/order';

interface CategoryTabsProps {
  categories: OrderCategory[];
  selectedCategory: string | null;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  return (
    <Box 
      sx={{ 
        position: 'relative',
        mb: 3,
        '&::after': {
          content: '""',
          position: 'absolute',
          right: 0,
          top: 0,
          height: '100%',
          width: '24px',
          background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.9))',
          pointerEvents: 'none',
          zIndex: 1,
        }
      }}
    >
      <Tabs
        value={selectedCategory}
        onChange={(_, newValue) => onCategoryChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          '& .MuiTabs-scrollButtons': {
            '&.Mui-disabled': {
              opacity: 0.3,
            },
          },
          '& .MuiTabs-indicator': {
            height: 3,
          },
          '& .MuiTab-root': {
            minHeight: '48px',
            fontSize: '0.875rem',
            fontWeight: 'bold',
            textTransform: 'none',
            '&.Mui-selected': {
              color: 'primary.main',
            },
          },
        }}
      >
        {categories.map((category) => (
          <Tab
            key={category.id}
            label={category.name}
            value={category.id}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoryTabs;
